import { z } from "zod";

// Self-service account profile update (passport-web /account → PUT /api/account).
// Full-resource PUT: the form posts every field each save. first/last are REQUIRED + non-blank — they
// are the canonical name and display_name is derived from them (sc-89494). .regex(/\S/) rejects
// all-whitespace. The address fields stay nullable + optional — an empty field is sent as `null`
// (explicit "clear"); `.max()`/`.length()` apply to non-null values. Lengths mirror passport.users
// (V006). country = ISO 3166-1 alpha-2; region = a geo_states code or free text.
export const updateAccountRequestSchema = z.object({
  first_name: z.string().min(1, "First name is required").max(100).regex(/\S/, "First name cannot be blank"),
  last_name: z.string().min(1, "Last name is required").max(100).regex(/\S/, "Last name cannot be blank"),
  address_line1: z.string().max(200).nullable().optional(),
  address_line2: z.string().max(200).nullable().optional(),
  city: z.string().max(100).nullable().optional(),
  region: z.string().max(100).nullable().optional(),
  postal_code: z.string().max(20).nullable().optional(),
  country: z.string().length(2).nullable().optional(),
});
